import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';
import { X } from 'lucide-react';

export function DeletableEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  data,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      {data?.isEditing && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <button
              type="button"
              className="bg-destructive text-destructive-foreground flex h-5 w-5 cursor-pointer items-center justify-center rounded-full shadow-md transition-transform hover:scale-125 hover:bg-red-600"
              onClick={(e) => {
                e.stopPropagation();
                if (typeof data.onDelete === 'function') {
                  data.onDelete();
                }
              }}
            >
              <X className="h-3 w-3 leading-none" />
            </button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
